var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var objectKeys = function (object) { return Object.keys(object); };
var objectFromEntries = function (pairs) {
    return Object.fromEntries(pairs);
};
var objectEntries = function (object) {
    return Object.entries(object);
};
/**
 * @deprecated use `createCssVarDefinitions` from `@creditornot/cb-utils` instead.
 *
 * Creates CSS variable definitions to be inserted in CSS.
 *
 * Input
 * `{ background: 'blue', text: 'black' }`
 * Ouput
 * `'--background: blue; --text: black;'`
 */
export function createCssVarDefinitions(varMap) {
    return objectEntries(varMap)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return "--".concat(key, ": ").concat(value, ";");
    })
        .join('\n');
}
/**
 * @deprecated use `createCssVars` from `@creditornot/cb-utils` instead.
 *
 * Creates an object map of CSS variables.
 *
 * Input
 * `['background', 'text']`
 * Output
 * `{ background: 'var(--background)', text: 'var(--text)' }`
 */
export function createCssVars(varConfig) {
    var varMap = Array.isArray(varConfig)
        ? Object.fromEntries(varConfig.map(function (key) { return [key, "var(--".concat(key, ")")]; }))
        : objectFromEntries(objectEntries(varConfig).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return [
                key,
                "var(--".concat(key, ", ").concat(typeof value === 'object' ? value.light : value, ")"),
            ];
        }));
    Object.freeze(varMap);
    return varMap;
}
/** @deprecated use `createCssVars` from `@creditornot/cb-utils` instead. */
export var createCssVarMap = createCssVars;
function createCssVarDefinitionsThemed(varMap, theme) {
    return objectEntries(varMap)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return typeof value === 'object' && theme ? "--".concat(key, ": ").concat(value[theme], ";") : "--".concat(key, ": ").concat(value, ";");
    })
        .join('\n');
}
/**
 * @deprecated use `createThemedCssVarDefinitions` from `@creditornot/cb-utils` instead.
 *
 * Creates definitions for given CSS var configuration with `data-cb-theme` based theme selectors.
 */
export function createThemedCssVarDefinitions(selector, varMap) {
    return "\n    ".concat(selector, "[data-cb-theme='light'] && {\n      ").concat(createCssVarDefinitionsThemed(varMap, 'light'), "\n    }\n\n    ").concat(selector, "[data-cb-theme='dark'] && {\n      ").concat(createCssVarDefinitionsThemed(varMap, 'dark'), "\n    }\n  ");
}
/**
 * @deprecated use `themedConfigToThemedAttrs` from `@creditornot/cb-utils` instead.
 *
 * Transforms
 * `{ light: { bg, color }, dark: { bg, color } }`
 * to
 * `{ bg: { light, dark }, color: { light, dark } }`
 */
export function themedConfigToThemedAttrs(variantConfig) {
    return objectFromEntries(objectKeys(variantConfig.light).map(function (key) { return [
        key,
        { light: variantConfig.light[key], dark: variantConfig.dark[key] },
    ]; }));
}
/**
 * Transforms
 * `{ bg: { light, dark }, color: { light, dark } }`
 * to
 * `{ bg, color }`
 */
function themedVarsToFlatVars(varMap, themeMode) {
    return objectFromEntries(objectEntries(varMap).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return [
            key,
            typeof value === 'string' ? value : value[themeMode],
        ];
    }));
}
/**
 * Temporary utility until styled-components context dependency
 * is removed from Cookbook.
 *
 * Inserts variables with CSS theme selectors if `cbThemeMode` is undefined.
 * Otherwise, just inserts variables without selectors.
 * This logic exists to make it work also without `data-cb-theme` class
 * for the migration period.
 */
export function cssVarsThemed(varMap) {
    return function (_a) {
        var cbThemeMode = _a.theme.cbThemeMode;
        return cbThemeMode === undefined
            ? createThemedCssVarDefinitions('', varMap)
            : createCssVarDefinitions(themedVarsToFlatVars(varMap, cbThemeMode));
    };
}
var BASE_FONT_SIZE = 16;
/**
 * Convert value in pixels to rem.
 */
export function pxToRem(px) {
    return "".concat(px / BASE_FONT_SIZE, "rem");
}
//# sourceMappingURL=cssUtils.js.map